import React from 'react';
import './privacy.css';

function PrivacyAndPolicies() {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy for Eye Care Optical</h1>
      <p>
        At Eye Care Optical, we are committed to protecting the privacy and security of our customers' personal
        information. This Privacy Policy outlines how we collect, use, and safeguard your information when you visit
        or make a purchase on our website. By using our website, you consent to the practices described in this policy.
      </p>
      <h2>Information We Collect</h2>
      <ul>
        <li>Personal identification information (name, email address, phone number) provided during registration or checkout.</li>
        <li>Payment and billing information handled securely by third-party processors.</li>
        <li>Browsing information (IP address, browser type, device details) collected via cookies and similar technologies.</li>
      </ul>
      <h2>Use of Information</h2>
      <p>We may use the collected information to:</p>
      <ul>
        <li>Process and fulfill your orders, including shipping and delivery.</li>
        <li>Communicate with you regarding purchases, support, and inquiries.</li>
        <li>Personalize your shopping experience with recommendations and promotions.</li>
        <li>Enhance our website, products, and services based on user feedback.</li>
        <li>Detect and prevent fraud, unauthorized activities, and website abuse.</li>
      </ul>
      <h2>Information Sharing</h2>
      <p>
        We respect your privacy and do not sell, trade, or transfer your personal information to third parties, except
        under these circumstances:
      </p>
      <ul>
        <li>
          <strong>Trusted service providers:</strong> Third-party service providers assisting with website operations,
          payment processing, and product delivery under strict confidentiality agreements.
        </li>
        <li>
          <strong>Legal requirements:</strong> Compliance with legal obligations, such as responding to valid legal
          requests or orders.
        </li>
      </ul>
      <h2>Data Security</h2>
      <p>
        We implement industry-standard security measures to protect your personal information. However, no internet or
        electronic storage method is 100% secure, and we cannot guarantee absolute security.
      </p>
      <h2>Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar technologies to improve your browsing experience and gather analytical data. You may
        disable cookies in your browser settings, but this could limit website functionality.
      </p>
      <h2>Changes to the Privacy Policy</h2>
      <p>
        We reserve the right to update this Privacy Policy at any time. Changes will be posted here with a revised "last
        updated" date.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions about our Privacy Policy, please contact us through the information provided on our
        website.
      </p>
    </div>
  );
}

export default PrivacyAndPolicies;

